import { render, staticRenderFns } from "./TruckLog.vue?vue&type=template&id=541918dc&scoped=true&"
import script from "./TruckLog.vue?vue&type=script&lang=js&"
export * from "./TruckLog.vue?vue&type=script&lang=js&"
import style0 from "./TruckLog.vue?vue&type=style&index=0&id=541918dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541918dc",
  null
  
)

export default component.exports